export const VERIFY_CODE = {
    maxLength: 5,
    resendInterval: 60000,
    pattern: '^[0-9]{5}$',
};
export const SEND_CODE_LOADER = 'code-resender-send-code';
export const CALL_ME_LOADER = 'code-resender-call-me';
